var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVikas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 443.6 406.3",
    style: {
      enableBackground: "new 0 0 443.6 406.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "90.5,82.1 56.7,82.1 79.1,150.7 112.1,150.7  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.5,82.1h-2.2l-40.9,119.5c-10.8,31.6-20.8,62.1-27.6,90.1H154c-6.5-28.4-15.4-57.8-25.9-90.4l-1.5-4.8H94L135.7,324 h34.5l55.4-154.9l31.1-87H225.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.7,217.1l1.2,1.8L274.7,217.1l73.8,106.4h37l-92.9-133.4l94.3-108.3h-38.8l-80.6,96.5c-3.3,4.3-6.8,8.8-10.3,13.6 l13.1,18.8l0.1-0.1L274.7,217.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.2,
    y: 214.6,
    width: 32,
    height: 110
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVikas);
export default __webpack_public_path__ + "static/media/vikas.6987b60652ebb63d5eb8a8a1507f5475.svg";
export { ForwardRef as ReactComponent };